import throttle from "./component-library136.mjs";
import zoomIcon from "./component-library164.mjs";
import GoliathImageElement from "./component-library15.mjs";
import Arrow from "./component-library4.mjs";
import LinkButton from "./component-library3.mjs";
import "./component-library165.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "ImageGallery2023",
  components: {
    LinkButton,
    Arrow,
    zoomIcon,
    GoliathImageElement
  },
  props: {
    images: {
      type: Array,
      required: true
    },
    initialSelectedIndex: {
      type: Number,
      default: 0
    },
    noZoom: {
      type: Boolean
    }
  },
  emits: ["zoom", "selected-image"],
  data() {
    return {
      selectedImageIndex: this.initialSelectedIndex,
      componentTexts: {
        zoom: "Vergrößern",
        selectImage: "Bild Anzeigen",
        controlGroup: "Bilder Navigation",
        prevControl: "Vorheriges Bild",
        nextControl: "Nächstes Bild"
      },
      scrollPosition: 0,
      showScrollUpButton: false,
      showScrollDownButton: false,
      scrollContainer: null,
      onScroll: throttle(this.handleScroll, 200)
    };
  },
  computed: {
    imageCount() {
      return this.images.length;
    },
    lastImageIndex() {
      return this.imageCount - 1;
    },
    hasMultipleImages() {
      return this.imageCount > 1;
    },
    selectedImage() {
      return this.images[this.selectedImageIndex];
    }
  },
  watch: {
    initialSelectedIndex(newIndex) {
      this.selectImage(newIndex);
    },
    images: {
      handler() {
        this.selectedImageIndex = 0;
        this.selectImage(0);
      },
      deep: true
    },
    selectedImage(value) {
      this.$emit("selected-image", value);
    }
  },
  mounted() {
    if (!this.hasMultipleImages)
      return;
    this.$nextTick(() => {
      setTimeout(() => {
        var _a;
        this.scrollContainer = this.$refs.thumbnailsContainer;
        (_a = this.scrollContainer) == null ? void 0 : _a.addEventListener("scroll", this.onScroll);
        this.handleScroll();
      }, 500);
    });
  },
  methods: {
    selectImage(index) {
      this.selectedImageIndex = Math.max(0, Math.min(index, this.lastImageIndex));
    },
    incrementSelectedImageIndex() {
      if (this.selectedImageIndex === this.lastImageIndex) {
        this.selectImage(0);
        return;
      }
      this.selectImage(this.selectedImageIndex + 1);
    },
    decrementSelectedImageIndex() {
      if (this.selectedImageIndex === 0) {
        this.selectImage(this.lastImageIndex);
        return;
      }
      this.selectImage(this.selectedImageIndex - 1);
    },
    emitClick() {
      if (!this.noZoom) {
        this.$emit("zoom", {
          ref: this.$refs.zoomImageLink,
          zoomParams: this.componentTexts.zoom.toLowerCase(),
          selectedImageIndex: this.selectedImageIndex,
          selectedImage: this.selectedImage
        });
      }
    },
    handleScroll() {
      if (!this.scrollContainer)
        return;
      const isFullyScrolled = Math.abs(
        this.scrollContainer.scrollHeight - this.scrollContainer.scrollTop - this.scrollContainer.clientHeight
      ) < 3;
      if (this.scrollContainer) {
        this.showScrollUpButton = this.scrollContainer.scrollTop !== 0;
        this.showScrollDownButton = !isFullyScrolled;
      }
    },
    scrollUp() {
      if (!this.scrollContainer)
        return;
      this.scrollContainer.scrollTop -= this.scrollContainer.clientHeight;
    },
    scrollDown() {
      if (!this.scrollContainer)
        return;
      this.scrollContainer.scrollTop += this.scrollContainer.clientHeight;
    },
    ariaHidden(index, currentIndex) {
      return index === currentIndex;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "image-gallery" }, [_c("div", { directives: [{ name: "touch", rawName: "v-touch:swipe.left", value: _vm.incrementSelectedImageIndex, expression: "incrementSelectedImageIndex", arg: "swipe", modifiers: { "left": true } }, { name: "touch", rawName: "v-touch:swipe.right", value: _vm.decrementSelectedImageIndex, expression: "decrementSelectedImageIndex", arg: "swipe", modifiers: { "right": true } }], staticClass: "image-gallery__stage", on: { "click": _vm.emitClick } }, [_vm._t("stageImage", function() {
    return [_vm.selectedImage ? _c("GoliathImageElement", { staticClass: "image-gallery__image", attrs: { "image": _vm.selectedImage, "alt": _vm.selectedImage.name, "xs-width": "medium", "sm-width": "large" } }) : _vm._e()];
  }, { "selectedImage": _vm.selectedImage, "index": _vm.selectedImageIndex }), _vm.$slots.badge ? [_vm._t("badge", null, { "index": _vm.selectedImageIndex })] : _vm._e(), !_vm.noZoom ? _c("zoomIcon", { staticClass: "image-gallery__zoom-icon" }) : _vm._e()], 2), _vm.hasMultipleImages ? _c("div", { staticClass: "image-gallery__controls", attrs: { "role": "group", "aria-label": _vm.componentTexts.controlGroup } }, [_c("Arrow", { staticClass: "image-gallery__arrow image-gallery__control--prev", attrs: { "set-position": "", "direction": "left", "aria-label": _vm.componentTexts.prevControl }, on: { "change": _vm.decrementSelectedImageIndex } }), _c("Arrow", { staticClass: "image-gallery__arrow image-gallery__control--next", attrs: { "set-position": "", "direction": "right", "aria-label": _vm.componentTexts.nextControl }, on: { "change": _vm.incrementSelectedImageIndex } })], 1) : _vm._e(), _vm.hasMultipleImages ? _c("div", { staticClass: "image-gallery__thumbnails" }, [_c("Arrow", { staticClass: "image-gallery__arrow image-gallery__arrow--upward", class: { "image-gallery__arrow--upward-show": _vm.showScrollUpButton }, attrs: { "set-position": "", "direction": "top", "aria-label": _vm.componentTexts.prevControl }, on: { "change": _vm.scrollUp } }), _c("ul", { ref: "thumbnailsContainer", staticClass: "image-gallery__thumbnails-container" }, _vm._l(_vm.images, function(image, index) {
    return _c("li", { key: index, staticClass: "image-gallery__thumbnail", class: { "image-gallery__thumbnail--current": index === _vm.selectedImageIndex }, attrs: { "data-image-path": image.path } }, [_c("LinkButton", { staticClass: "image-gallery__thumbnail-link", attrs: { "tag": "button", "no-styling": "", "title": _vm.componentTexts.selectImage, "aria-label": _vm.componentTexts.selectImage }, on: { "click": function($event) {
      $event.preventDefault();
      return _vm.selectImage(index);
    } } }, [_vm._t("thumbImage", function() {
      return [_c("GoliathImageElement", { attrs: { "aria-hidden": _vm.ariaHidden(index, _vm.selectedImageIndex), "data-testid": `thumb-${index}`, "image": image, "xs-width": "small", "sm-width": "small", "alt": image.name, "render-without-figure": "", "lazy": "" } })];
    }, null, { image, index, selectedImageIndex: _vm.selectedImageIndex })], 2)], 1);
  }), 0), _c("Arrow", { staticClass: "image-gallery__arrow image-gallery__arrow--downward", class: { "image-gallery__arrow--downward-show": _vm.showScrollDownButton }, attrs: { "set-position": "", "direction": "bottom", "aria-label": _vm.componentTexts.prevControl }, on: { "change": _vm.scrollDown } })], 1) : _vm._e(), !_vm.noZoom ? _vm._t("lightbox", null, { "selectedImage": _vm.selectedImage }) : _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "5904cc1a",
  null,
  null
);
const imageGallery2023 = __component__.exports;
export {
  imageGallery2023 as default
};
